// extracted by mini-css-extract-plugin
export default {"sbtH1":"SbtH1_sbtH1__gudXR"};